import { registerSW } from 'virtual:pwa-register';

export const registerServiceWorker = () => {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  if (import.meta.env.DEV || import.meta.env.MODE === 'development') {
    const workerUrl = new URL(`${import.meta.env.BASE_URL}sw.js`, window.location.origin).href;
    const wasControlled = navigator.serviceWorker.controller?.scriptURL === workerUrl;
    void navigator.serviceWorker
      .getRegistrations()
      .then(async (registrations) => {
        const ownRegistrations = registrations.filter((registration) =>
          [registration.active, registration.waiting, registration.installing].some(
            (worker) => worker?.scriptURL === workerUrl,
          ),
        );
        const removed = await Promise.all(ownRegistrations.map((registration) => registration.unregister()));
        if ('caches' in window) {
          const keys = await caches.keys();
          await Promise.all(
            keys
              .filter(
                (key) =>
                  ['app-chunks', 'app-pages', 'daily-snapshots'].includes(key) ||
                  (key.startsWith('workbox-precache-') &&
                    key.endsWith(new URL(import.meta.env.BASE_URL, window.location.origin).href)),
              )
              .map((key) => caches.delete(key)),
          );
        }
        if (wasControlled && removed.some(Boolean)) window.location.reload();
      })
      .catch(() => undefined);
    return;
  }

  // Remove data snapshots left by previous versions; resource caches remain intact.
  if ('caches' in window) void caches.delete('daily-snapshots').catch(() => undefined);

  registerSW({
    immediate: true,
    onRegisteredSW(_swUrl, registration) {
      if (!registration) return;
      let checking = false;

      const checkForUpdate = () => {
        if (document.visibilityState === 'visible' && navigator.onLine && !checking) {
          checking = true;
          void registration
            .update()
            .catch(() => undefined)
            .finally(() => {
              checking = false;
            });
        }
      };

      window.setInterval(checkForUpdate, 60_000);
      window.addEventListener('focus', checkForUpdate);
      window.addEventListener('online', checkForUpdate);
      document.addEventListener('visibilitychange', checkForUpdate);
      checkForUpdate();
    },
  });
};
